import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RightDrawerStore } from '@flexo/reducers';
import { FetchEnergyRankingUnifiedAsync } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';
import { getMemberSiteIds } from './helpers';

export const EnergyMemberRankingResolver = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);
  const pathSegment = location.pathname.split('/')[1]; 

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {

    if (!location.pathname.includes('member')) { return; }

    const MEMBER_ID = params?.id || metadata?.selectedEntity?.memberId || null;

    if (!MEMBER_ID) { return; }

    const ENV = (import.meta as any).env;
    const org = ENV?.VITE_APP_ORG || 'base';
    const totalSites = getMemberSiteIds(metadata, MEMBER_ID).length;
    const fetchAll = RightDrawerStore()?.show === true && RightDrawerStore()?.type === 'HORIZONTAL_CHART';

    // Token auto-injected by httpService interceptor
    dispatch((FetchEnergyRankingUnifiedAsync as any)({
      org,
      scope: 'member',
      entityId: MEMBER_ID,
      totalSites,
      selectedDate,
      selectedTimeSet,
      fetchAll,
    }));
  }

  useEffect(() => {
      init();
  }, []);

  useEffect(() => {
      init();
  }, [selectedDate, params?.id, pathSegment]);

  return <></>;
};
